module.exports = __webpack_public_path__ + "2b4eeeaef53b3496a5cdf82803666ed7.svg";